<template>
  <loader :task="task" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { QueryResult, CollectionFilters } from '@/type';
import { PostImport } from '@/social/types';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import repository from './post-import-repository';

interface Data {
  task: Promise<QueryResult<PostImport>>|null,
}

export default defineComponent({
  emits: ['loaded'],
  components: {
    Loader,
  },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    filters: {
      type: Object as () => CollectionFilters,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  watch: {
    accountId: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
    filters: {
      handler(): void {
        this.load();
      },
      deep: true,
    },
  },
  methods: {
    load(): void {
      this.task = repository.findAll(this.accountId, this.filters);
      this.task.then((result) => {
        this.$emit('loaded', result);
      });
    },
  },
});
</script>
